/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import "./AddPaymentMethodSection.scss";
import BreadCrumbComponent from "../../Misc/BreadCrumb/BreadCrumbComponent";
import PaymentMethodFormSection from "./PaymentMethodFormSection/PaymentMethodFormSection";
import useLogin from "../../../../custom-hooks/useLogin";
import {
  fetchSubscriptionCardInfo,
  fetchSubscriptionCardInfoClear,
  setPaymentMethodDetailClear,
} from "../../../../redux/payment/actions";
import CONFIG from "../../../../utils/config";
import API_LIST from "../../../../utils/apiList";
import { SessionKeys } from "../../../../utils/AppUtils";
import { routeList } from "../../../../utils/routeList";

const AddPaymentMethodSection = (props) => {
  const { isMobile, loggedIn } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isLoggedIn, userData } = useLogin();

  const paymentMethodDetail = useSelector(
    (state) => state.payment.paymentMethod
  );
  const cardInfo = useSelector((state) => state.payment.cardInfo);
  const updateCardInfo = useSelector((state) => state.payment.updateCardInfo);

  const [existingCardData, setExistingCardData] = useState({});
  const [enableFormField, setEnableFormField] = useState(true);
  const [subscriptionId, setSubscriptionId] = useState("");
  const [breadCrumbData, setBreadCrumbData] = useState([
    {
      name: "Subscription",
      active: false,
      link: routeList.SUBSCRIPTION_PAGE,
      isLoading: false,
    },
    { name: "Payment", active: false, link: "", isLoading: false },
    { name: "Update should be Subscription", active: false, link: "", isLoading: false },
    { name: "Update Payment Details", active: true, link: "", isLoading: false },
  ]);

  useEffect(() => {
    console.log(
      "PAYMENO METHOD DETAIL",
      paymentMethodDetail,
      paymentMethodDetail.stripeSubscriptionId,
      isLoggedIn,
      loggedIn
    );
    if (
      !_.isEmpty(paymentMethodDetail) &&
      paymentMethodDetail.stripeSubscriptionId &&
      (isLoggedIn || localStorage.getItem(SessionKeys.API_TOKEN))
    ) {
      console.log("PAYMENO METHOD DETAIL 2", paymentMethodDetail);
      setSubscriptionId(paymentMethodDetail.stripeSubscriptionId);
      dispatch(
        fetchSubscriptionCardInfo({
          URL: `${CONFIG.API_URL_BROKER}${API_LIST.ECOM_API.GET_CARD_INFO}`,
          isJSON: true,
          method: "post",
          payload: {
            token: isMobile
              ? localStorage.getItem(SessionKeys.API_TOKEN)
              : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            subscription_id: paymentMethodDetail.stripeSubscriptionId,
          },
        })
      );
      dispatch(setPaymentMethodDetailClear());
    }
  }, [paymentMethodDetail, isLoggedIn]);

  useEffect(() => {
    console.log("card---", cardInfo);
    if (!_.isEmpty(cardInfo)) {
      if (cardInfo.status === "success") {
        const payload = cardInfo.payload.data;
        console.log(payload);
        if (!_.isEmpty(payload) && !_.isEmpty(payload.card_data)) {
          setExistingCardData(payload.card_data);
        }
      }
      dispatch(fetchSubscriptionCardInfoClear());
    }
  }, [cardInfo]);

  useEffect(() => {
    if (!_.isEmpty(updateCardInfo)) {
      navigate(`/payment/processing?type=subscription&isMobile=${isMobile}`);
    }
  }, [updateCardInfo]);

  const renderCardUI = () => {
    return (
      <>
        <div className="cc-area">
          <div className="cc-title">Currently Used Card:</div>
            <div className="cc-design">
              <div className="d-flex justify-content-end">
                {/* CARDLOGO */}
              </div>
              <div className="d-flex gap-2 w-100">
                <div className="d-flex flex-column">
                  <div className="cc-card-name">
                    {userData?.firstname}&nbsp;{userData.lastname}
                  </div>
                  <div className="cc-card-line">
                    **** **** **** {existingCardData.card_last4}
                  </div>
                  <div className="cc-expiry">
                    {existingCardData.card_exp_month}&nbsp;/&nbsp;
                    {existingCardData.card_exp_year}
                  </div>
                </div>
              </div>
            </div>
        </div>
      </>
    );
  };

  return (
    <>
      <div className="row payment-b2c">
        <div className="col-12">
          <div className="col-lg-6 col-12">
            <div className="bred-icof justify-content-between">
              <BreadCrumbComponent crumbList={breadCrumbData} />
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-md-12">
          <h2 className="cart-title-b2c">Update Payment Detail</h2>
          {/* <p className="sub-cart-title">There are 3 items in your cart</p> */}
        </div>
      </div>
      <div className="row">
        <div className="col-lg-8 col-12">
          <PaymentMethodFormSection
            enableFormField={enableFormField}
            setEnableFormField={setEnableFormField}
            subscriptionId={subscriptionId}
          />
        </div>
        <div className="col-lg-4 col-12">
          {!_.isEmpty(existingCardData) ? renderCardUI() : ""}
        </div>
      </div>
    </>
  );
};

export default AddPaymentMethodSection;
